import React, { FC } from 'react'
import styled from 'styled-components'

export interface ModalProps {
  children?: React.ReactNode
  onClose: () => void
  show: boolean
}

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;

  * {
    font-family: Jua;
  }

  .modal {
    width: calc(100% - 2.4rem);
    min-height: 100px;
    max-height: calc(100% - 2rem);
    border: 1px solid #ffc83c;
    border-radius: 1.5rem;
    background-color: #fff;
    padding: 3rem 1.2rem 2rem;
    position: relative;
    color: #d48d4f;

    .close-modal {
      position: absolute;
      top: 1rem;
      right: 1rem;
      cursor: pointer;
      padding: 0;
      background: none;
      border: none;
      outline: none;
    }

    .modal-header {
      padding: 0.5rem 1.5rem;
      background-color: #ffc737;
      border-bottom: 3px solid #cc6606;
      border-radius: 1rem;
      text-align: center;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: -1.5rem;
      font-size: 1.8rem;
      color: #fff;
      -webkit-text-stroke-width: 1px;
      -webkit-text-stroke-color: #d18d00;
      font-family: Jua;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      white-space: nowrap;

      &.small {
        font-size: 1.6rem;
        padding: 0.3rem 1.3rem;
      }
    }

    b,
    strong {
      color: #c15a00;
    }
  }
`

const Modal: FC<ModalProps> = ({ children, onClose, show }) => {
  return show ? (
    <ModalWrapper>
      <div className={'modal'}>
        <button className={'close-modal'} onClick={onClose}>
          <svg width='20' height='20' viewBox='0 0 56 56' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <mask id='path-1-inside-1_541_21' fill='white'>
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M3.10107 3.10108C0.18255 6.0196 0.182553 10.7515 3.10107 13.67L17.6334 28.2023L3.10117 42.7344C0.182657 45.653 0.182659 50.3848 3.10118 53.3033C6.01969 56.2218 10.7516 56.2218 13.6701 53.3033L28.2022 38.7711L42.7344 53.3033C45.6529 56.2218 50.3848 56.2218 53.3033 53.3033C56.2218 50.3848 56.2218 45.6529 53.3033 42.7344L38.7711 28.2023L53.3034 13.67C56.2219 10.7515 56.2219 6.01961 53.3034 3.10109C50.3849 0.182572 45.653 0.182575 42.7345 3.10109L28.2022 17.6334L13.67 3.10108C10.7514 0.182563 6.01959 0.182563 3.10107 3.10108Z'
              />
            </mask>
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M3.10107 3.10108C0.18255 6.0196 0.182553 10.7515 3.10107 13.67L17.6334 28.2023L3.10117 42.7344C0.182657 45.653 0.182659 50.3848 3.10118 53.3033C6.01969 56.2218 10.7516 56.2218 13.6701 53.3033L28.2022 38.7711L42.7344 53.3033C45.6529 56.2218 50.3848 56.2218 53.3033 53.3033C56.2218 50.3848 56.2218 45.6529 53.3033 42.7344L38.7711 28.2023L53.3034 13.67C56.2219 10.7515 56.2219 6.01961 53.3034 3.10109C50.3849 0.182572 45.653 0.182575 42.7345 3.10109L28.2022 17.6334L13.67 3.10108C10.7514 0.182563 6.01959 0.182563 3.10107 3.10108Z'
              fill='#FFC737'
            />
            <path
              d='M3.10107 13.67L3.80818 12.9629L3.10107 13.67ZM17.6334 28.2023L18.3405 28.9094L19.0476 28.2023L18.3405 27.4952L17.6334 28.2023ZM3.10117 42.7344L2.39407 42.0273L2.39407 42.0273L3.10117 42.7344ZM28.2022 38.7711L28.9094 38.064L28.2022 37.3569L27.4951 38.064L28.2022 38.7711ZM53.3033 42.7344L52.5962 43.4415L53.3033 42.7344ZM38.7711 28.2023L38.064 27.4952L37.3569 28.2023L38.064 28.9094L38.7711 28.2023ZM53.3034 13.67L52.5963 12.9629L53.3034 13.67ZM42.7345 3.10109L43.4416 3.8082L42.7345 3.10109ZM28.2022 17.6334L27.4951 18.3405L28.2022 19.0476L28.9094 18.3405L28.2022 17.6334ZM3.80818 12.9629C1.28018 10.4349 1.28018 6.33618 3.80817 3.80819L2.39396 2.39398C-0.915082 5.70302 -0.915077 11.068 2.39396 14.3771L3.80818 12.9629ZM18.3405 27.4952L3.80818 12.9629L2.39396 14.3771L16.9262 28.9094L18.3405 27.4952ZM3.80828 43.4415L18.3405 28.9094L16.9262 27.4952L2.39407 42.0273L3.80828 43.4415ZM3.80828 52.5962C1.28029 50.0682 1.28029 45.9695 3.80828 43.4415L2.39407 42.0273C-0.914974 45.3364 -0.914972 50.7014 2.39407 54.0104L3.80828 52.5962ZM12.963 52.5962C10.435 55.1242 6.33627 55.1242 3.80828 52.5962L2.39407 54.0104C5.70311 57.3195 11.0681 57.3195 14.3772 54.0104L12.963 52.5962ZM27.4951 38.064L12.963 52.5962L14.3772 54.0104L28.9094 39.4783L27.4951 38.064ZM43.4415 52.5962L28.9094 38.064L27.4951 39.4783L42.0273 54.0104L43.4415 52.5962ZM52.5962 52.5962C50.0682 55.1242 45.9695 55.1242 43.4415 52.5962L42.0273 54.0104C45.3363 57.3195 50.7014 57.3195 54.0104 54.0104L52.5962 52.5962ZM52.5962 43.4415C55.1242 45.9695 55.1242 50.0682 52.5962 52.5962L54.0104 54.0104C57.3195 50.7014 57.3194 45.3364 54.0104 42.0273L52.5962 43.4415ZM38.064 28.9094L52.5962 43.4415L54.0104 42.0273L39.4782 27.4952L38.064 28.9094ZM52.5963 12.9629L38.064 27.4952L39.4782 28.9094L54.0105 14.3771L52.5963 12.9629ZM52.5963 3.8082C55.1243 6.33619 55.1243 10.4349 52.5963 12.9629L54.0105 14.3771C57.3196 11.068 57.3196 5.70303 54.0105 2.39398L52.5963 3.8082ZM43.4416 3.8082C45.9696 1.28021 50.0683 1.2802 52.5963 3.8082L54.0105 2.39398C50.7015 -0.91506 45.3365 -0.915056 42.0274 2.39399L43.4416 3.8082ZM28.9094 18.3405L43.4416 3.8082L42.0274 2.39399L27.4951 16.9263L28.9094 18.3405ZM12.9628 3.80819L27.4951 18.3405L28.9094 16.9263L14.3771 2.39397L12.9628 3.80819ZM3.80817 3.80819C6.33617 1.28019 10.4349 1.28019 12.9628 3.80819L14.3771 2.39397C11.068 -0.915068 5.703 -0.915068 2.39396 2.39398L3.80817 3.80819Z'
              fill='#CC6606'
              mask='url(#path-1-inside-1_541_21)'
            />
          </svg>
        </button>
        {children}
      </div>
    </ModalWrapper>
  ) : null
}

export default Modal
